import React from "react";
import SingleLanguageSelector from "./SingleLanguageSelector";

interface Language {
  language_name: string;
  iso639_tag: string;
}

interface FormUpdate {
  updateType: string;
  value: string;
}

interface LanguageSelectorProps {
  selectedNativeLanguage: string;
  selectedTargetLanguage: string;
  updateFormValue: (update: FormUpdate) => void;
}

const LanguageSelector = ({ selectedNativeLanguage, selectedTargetLanguage, updateFormValue }: LanguageSelectorProps) => {
    const languages: Language[] = [
      { language_name: 'Inglés', iso639_tag: 'en-US' },
      { language_name: 'Español', iso639_tag: 'es-CL' },
      { language_name: 'Alemán', iso639_tag: 'de-DE' }
    ];
  
    return (
      <div className="form-control w-full">
        <SingleLanguageSelector
          label="Tu idioma nativo"
          selectedValue={selectedNativeLanguage}
          updateType="selectedNativeLanguage"
          updateFormValue={updateFormValue}
          languages={languages}
        />
  
        <SingleLanguageSelector
          label="Idioma que quieres aprender"
          selectedValue={selectedTargetLanguage}
          updateType="selectedTargetLanguage"
          updateFormValue={updateFormValue}
          languages={languages}
          exclude={[selectedNativeLanguage]}
          disabled={!selectedNativeLanguage}
        />
      </div>
    );
  };
  
  export default LanguageSelector;

